import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: () => import(/* webpackChunkName: "Home" */ "@/views/home")
  },
  {
    path: "/news-feed",
    name: "Media",
    component: () => import("@/views/newsfeed"),
    meta: {
      module: "Media",
      isHeaderVisible: true,
      isFooterVisible: true,
      isLeftBarVisible: true,
      breadCrumb: [
        {
          text: "Media",
          href: "/"
        }
      ]
    }
  },
  {
    path: "/newsfeed/view/:id",
    name: "Newsfeed Detail",
    component: () => import("@/views/newsfeed/Detail.vue"),
    meta: {
      guest: true,
      module: "Media",
      isHeaderVisible: true,
      isFooterVisible: true,
      isLeftBarVisible: true,
      breadCrumb: [
        {
          text: "News & Articles",
          href: "/"
        }
      ]
    }
  },
  {
    path: "/find-doctor",
    name: "Find-Doctors",
    component: () =>
      import(/* webpackChunkName: "findDoctor" */ "@/views/find-doctor"),
    meta: {
      module: "Find Doctor",
      isHeaderVisible: true,
      isFooterVisible: true,
      isLeftBarVisible: true
    }
  },
  {
    path: "/login",
    name: "Login",
    component: () => import(/* webpackChunkName: "login" */ "@/views/Login.vue")
  },
  {
    path: "/signup",
    name: "Signup",
    component: () =>
      import(/* webpackChunkName: "signup" */ "@/views/Signup.vue"),
    meta: {
      isLeftBarVisible: false
    }
  },
  {
    path: "/forgot-password",
    name: "Forgot-Password",
    component: () =>
      import(/* webpackChunkName: "forgotPassword" */ "@/views/ForgotPassword"),
    meta: {
      guest: true
    }
  },
  {
    path: "/privacy-policy",
    name: "Privacy Policy",
    component: () => import("@/views/PrivacyPolicy"),
    meta: {
      guest: true
    }
  },
  {
    path: "/terms&conditions",
    name: "Terms & Conditions",
    component: () => import("@/views/TermsConditions"),
    meta: {
      guest: true
    }
  },
  {
    path: "/change-password/:token",
    name: "Change-Password",
    component: () =>
      import(/* webpackChunkName: "changePassword" */ "@/views/ChangePassword"),
    meta: {
      guest: true
    }
  },
  {
    path: "/403",
    name: "Permission-Denied",
    component: () =>
      import(/* webpackChunkName: "forbidden" */ "@/views/Forbidden.vue")
  },
  {
    path: "/signup-link",
    name: "Signup-Link",
    component: () =>
      import(/* webpackChunkName: "signuplink" */ "@/views/SignupLink.vue")
  },
  {
    path: "/profile",
    name: "Profile",
    component: () =>
      import(/* webpackChunkName: "profile" */ "@/views/profile"),
    meta: {
      requiresAuth: true,
      module: "Profile",
      breadCrumb: [
        {
          text: "Profile",
          href: "/profile"
        }
      ]
    }
  },
  {
    path: "/newsfeed",
    name: "NewsFeeds",
    component: () => import("@/views/newsfeed"),
    meta: {
      requiresAuth: true,
      module: "Media",
      breadCrumb: [
        {
          text: "News & Articles",
          href: ""
        }
      ]
    }
  },
  {
    path: "/findDoctor",
    name: "Find-Doctor",
    component: () =>
      import(/* webpackChunkName: "findDoctor" */ "@/views/find-doctor"),
    meta: {
      requiresAuth: true,
      module: "Find Doctor",
      breadCrumb: [
        {
          text: "Home",
          href: "/"
        },
        {
          text: "Find-Doctors",
          href: ""
        }
      ]
    }
  },
  {
    path: "/book-appointment/:doctorId/:workplaceId",
    name: "Book-Appointment",
    component: () =>
      import(/* webpackChunkName: "booking" */ "@/views/booking"),
    meta: {
      guest: true,
      isHeaderVisible: true,
      isFooterVisible: true,
      isLeftBarVisible: true,
      module: "Doctor Details",
      breadCrumb: [
        {
          text: "Home",
          href: "/"
        },
        {
          text: "Find Doctor",
          href: "/findDoctor"
        },
        {
          text: "Doctor Details",
          href: ""
        }
      ]
    }
  },
  {
    path: "/book-appointment/:doctorId/:workplaceId/:bookingId",
    name: "Book-Appointment",
    component: () =>
      import(/* webpackChunkName: "booking" */ "@/views/booking"),
    meta: {
      requiresAuth: true,
      module: "Bookings"
    }
  },
  {
    path: "/appointment/list",
    name: "Bookings",
    component: () =>
      import(/* webpackChunkName: "booking" */ "@/views/booking/List"),
    meta: {
      requiresAuth: true,
      module: "Bookings",
      breadCrumb: [
        {
          text: "Home",
          href: "/newsfeed"
        },
        {
          text: "Appointment List"
        }
      ]
    }
  },
  {
    path: "/products",
    name: "Product List",
    component: () =>
      import(/* webpackChunkName: "product" */ "@/views/product/Index"),
    meta: {
      requiresAuth: true,
      module: "Products",
      breadCrumb: [
        {
          text: "Home",
          href: "/"
        },
        {
          text: "Products",
          href: ""
        }
      ]
    }
  },
  {
    path: "/products/view/:id",
    name: "Product Detail",
    component: () =>
      import(/* webpackChunkName: "product Detail" */ "@/views/product/Detail"),
    meta: {
      requiresAuth: true,
      module: "Products",
      breadCrumb: [
        {
          text: "Home",
          href: "/"
        },
        {
          text: "Products",
          href: "/products"
        }
      ]
    }
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 };
  }
});

router.beforeEach((to, from, next) => {
  const isLogin = store.state.user.isUserLoggedIn;
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!isLogin) {
      next({ name: "Login" });
    } else {
      next();
    }
  } else if (to.matched.some(record => record.meta.guest)) {
    if (!isLogin) {
      next();
    } else {
      next();
    }
  } else {
    if (!isLogin) {
      next();
    } else {
      next({ name: "NewsFeeds" });
    }
  }
});
export default router;
